import { SET_EDIT_LONG_READ } from '../actions/setEditLongRead';
import { ADD_LR_POST_SUCCESS } from '../actions/addLongReadPost';
import { updateObjectById } from "../utilites/newReducerHelpers";
var initialData = {
    isEdit: false,
    num: -1
};
var initialState = {};
export function setEditLongReadReducer(state, action) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (state === void 0) { state = initialState; }
    if (!((_a = action.payload) === null || _a === void 0 ? void 0 : _a.lgId))
        return state;
    switch (action.type) {
        case SET_EDIT_LONG_READ:
            // return { ...state, isEdit: action.payload.status, num: action.payload.num  }
            return updateObjectById(state, (_b = action.payload) === null || _b === void 0 ? void 0 : _b.lgId, { isEdit: (_d = (_c = action.payload) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.status, num: (_f = (_e = action.payload) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.num }, initialData);
        case ADD_LR_POST_SUCCESS:
            return updateObjectById(state, (_g = action.payload) === null || _g === void 0 ? void 0 : _g.lgId, initialData, initialData);
        default:
            return state;
    }
}
;
export function getCurrentEditLongread(state, lgId) {
    return state.editLongRead[lgId] || initialData;
}
//# sourceMappingURL=setEditLongRead.js.mapimport { SET_EDIT_LONG_READ } from '../actions/setEditLongRead';
import { ADD_LR_POST_SUCCESS } from '../actions/addLongReadPost';
import { updateObjectById } from "../utilites/newReducerHelpers";
var initialData = {
    isEdit: false,
    num: -1
};
var initialState = {};
export function setEditLongReadReducer(state, action) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (state === void 0) { state = initialState; }
    if (!((_a = action.payload) === null || _a === void 0 ? void 0 : _a.lgId))
        return state;
    switch (action.type) {
        case SET_EDIT_LONG_READ:
            // return { ...state, isEdit: action.payload.status, num: action.payload.num  }
            return updateObjectById(state, (_b = action.payload) === null || _b === void 0 ? void 0 : _b.lgId, { isEdit: (_d = (_c = action.payload) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.status, num: (_f = (_e = action.payload) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.num }, initialData);
        case ADD_LR_POST_SUCCESS:
            return updateObjectById(state, (_g = action.payload) === null || _g === void 0 ? void 0 : _g.lgId, initialData, initialData);
        default:
            return state;
    }
}
;
export function getCurrentEditLongread(state, lgId) {
    return state.editLongRead[lgId] || initialData;
}
//# sourceMappingURL=setEditLongRead.js.map